import request from '@/plugin/axios'

export function fetchList (query) {
  return request({
    url: '/basic/dtcarinfo/page',
    method: 'post',
    data: query
  })
}

export function addObj (obj) {
  return request({
    url: '/basic/dtcarinfo',
    method: 'post',
    data: obj
  })
}

export function getObj (id) {
  return request({
    url: '/basic/dtcarinfo/' + id,
    method: 'get'
  })
}

export function delObj (id) {
  return request({
    url: '/basic/dtcarinfo/' + id,
    method: 'delete'
  })
}

export function putObj (obj) {
  return request({
    url: '/basic/dtcarinfo',
    method: 'put',
    data: obj
  })
}
/**
 * 车辆档案 批量删除
 */
export function delObjs (ids) {
  return request({
    url: '/basic/dtcarinfo/delbyids',
    method: 'post',
    params: ids
  })
}
/**
 * 移出黑名单（设为白名单）
 */
export function isWhiteObjs (ids, removeBlackReason) {
  return request({
    url: '/basic/dtcarinfo/lockenable',
    method: 'post',
    params: { ...ids, removeBlackReason }
  })
}
/**
 * 设为黑名单
 */
export function isBlackObjs (ids, blackReason) {
  return request({
    url: '/basic/dtcarinfo/lockstop',
    method: 'post',
    params: { ...ids, blackReason }
  })
}
/**
 * 车牌号 判断是否重复
 */
export function getDetails (obj) {
  return request({
    url: '/basic/dtcarinfo/details/' + obj,
    method: 'get'
  })
}
/**
 * 通过搜索 得到车牌号名称
 */
export function getcarinfoName (search) {
  return request({
    url: '/basic/dtcarinfo/cosname',
    method: 'get',
    params: { search: search }
  })
}
/**
 * 定位 通过车牌号获取返回数据
 */
export function getGpsPosition (obj) {
  return request({
    url: '/tms/gps/pos',
    method: 'get',
    params: { carNo: obj }
  })
}
/**
 * 定位 通过车牌号获取返回数据
 */
export function getGpsTrack (carNo, startDate, endDate) {
  return request({
    url: '/tms/gps/locus',
    method: 'get',
    params: { carNo: carNo, startDate: startDate, endDate: endDate }
  })
}
/**
 * 车辆认证 获取信息
 */
export function getDriverMsg (obj) {
  return request({
    url: '/tms/auth/vehicle/driver/details',
    method: 'get',
    params: { phoneNo: obj }
  })
}
